import { Empty, Form, Input, message, Select, Table, TreeSelect, Row, Col, Button } from 'antd';
import React, { useContext, useState, useEffect } from 'react';
import ProviderUserTypeInfo from '../../../provider-userType-info';
import FilterBoxes from '@/components/filter-boxes';
import apis from '../../../apis';
import { filterConditions, formatPrice } from '@/common/utils';
import IconTip from '@/components/icon-tip';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import Copy from '@/components/copy';
import _, { divide } from 'lodash';
import CommonNoAccess from '@/pages/mvp-panel/participant-data/components/no-access';

const userTypeObj = {
  'placeErp': {
    "ord": "4",
    "value": "销售ERP",
    "key": "placeErp"
  },
  'dept':   {
    "ord": "1",
    "value": "运营部门",
    "key": "dept"
  },
  'erp': {
    "ord": "2",
    "value": "运营ERP",
    "key": "erp"
  },
  'placeDept': {
    "ord": "3",
    "value": "销售部门",
    "key": "placeDept"
  }
}
const userType = ['dept', 'erp']
function formatUserType(type){
  const typeList = type.map(item=>(item.key))
  const newTypeList = _.intersection(userType,typeList);
  return newTypeList.map(item=>(userTypeObj[item]))
}
function findFirstAvailableCode(arr) {
  if (!arr || !arr.length) return [];
  let fullCode = '';
  function findCode(list) {
    let code = '';
    code = list.find((item) => !item.disabled);
    if (!code && list[0].children && list[0].children.length) {
      findCode(list[0].children);
    } else {
      fullCode = code.deptFullCode;
    }
  }
  findCode(arr);
  return fullCode;
}

const activityType = [
  {
    label: '主题活动',
    value: 0,
  },
  {
    label: '日常活动',
    value: 1,
  },
  {
    label: '通天塔活动',
    value: 2,
  },
];
const activityTypeMap = {};
activityType.map((item) => {
  activityTypeMap[item.value] = item;
});
const activityStatus = [
  {
    label: '未开始',
    value: 0,
  },
  {
    label: '进行中',
    value: 2,
  },
  {
    label: '已结束',
    value: 1,
  },
];
const activityCycle = [
  {
    label: '短(1天)',
    value: 0,
  },
  {
    label: '中(<30天)',
    value: 1,
  },
  {
    label: '长(>=30天)',
    value: 2,
  },
];

const initConditions = {
  pageNum: 1,
  pageSize: 10,
  activityType: '',
  activityCycle: '',
  activityStatus: '',
  planName: '',
  // orderBy: '',
  // sequence: '',
  userType: '',
  buId: '',
  deptId1: '',
  deptId2: '',
  deptId3: '',
  deptId4: '',
  participant: '',
};

function ActivityTable(props) {
  const { gotoDetail } = props;
  // const value = useContext(ProviderUserTypeInfo);
  const [form] = Form.useForm();
  const [data, setData] = useState({
    total: 0,
    skuPoolPlanInfos: [],
  });

  const [dataScopeFilter, setDataScopeFilter] = useState();
  const [filter, setFilter] = useState();
  const [originFilter, setOriginFilter] = useState();
  const [userType, setUserType] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [noAccess, setNoAccess] = useState(false);

  const [inSecKill, setSecKill] = useState(null);

  const [conditions, setConditions] = useState(initConditions);
  useEffect(() => {
    // form && form.resetFields();
    // if (!value || !Object.keys(value).length) return;
    setConditions((conditions) => ({ ...conditions, ...initConditions, ...filter }));
  }, [form, filter]);

  useEffect(() => {
    const { userType } = conditions;
    if (!userType) return;
    let didMount = true;
    apis
      .queryPlanInfoList(filterConditions(conditions))
      .then((res) => {
        if (!didMount) return;
        const { ret, msg, data } = res;
        if (ret != 0 || !data) throw msg || '活动列表暂无数据';
        setData(data);
      })
      .catch((ex) => {
        message.error(ex);
      });
    return () => {
      didMount = false;
    };
  }, [conditions]);

  function onFinish(val) {
    setConditions((conditions) => Object.assign({}, conditions, val, { pageNum: 1 }));
  }

  function getFilterValue(value) {
    let formValues = {};
    if (value.userType == 'dept' || value.userType == 'placeDept') {
      const { dept } = value;
      const _dept = dept.split('/');
      let buId = _dept[0],
        deptId1 = _dept[1] || '全部',
        deptId2 = _dept[2] || '全部',
        deptId3 = _dept[3] || '全部',
        deptId4 = _dept[4] || '全部',
        participant = '全部';
      formValues = { userType: value.userType, buId, deptId1, deptId2, deptId3, deptId4, participant };
    }
    if (value.userType == 'erp' || value.userType == 'placeErp') {
      formValues = { userType: value.userType, participant: value.erp };
    }
    return filterConditions(formValues);
  }

  useEffect(() => {
    apis
      .queryGeneralDataScopeByErp()
      .then((res) => {
        setLoaded(true);
        const { ret, data } = res;
        if (ret === '0' && data && data.userType) {
          if(data.userType?.length > 0){
            data.userType = formatUserType(data.userType)
            setNoAccess(false)
          } else{
            setNoAccess(true)
          }
          setDataScopeFilter(data);
        } else {
          throw '暂无数据';
        }
      })
      .catch((ex) => {
        message.error(ex);
      });
  }, []);

  //初始值;
  useEffect(() => {
    if (!dataScopeFilter?.userType?.length) return;
    const { userType, dataScope } = dataScopeFilter;
    const _userType = userType[0]?.key;
    const value = {
      userType: _userType,
      dept:
        (_userType == 'dept' || _userType == 'placeDept') && dataScope[_userType]
          ? findFirstAvailableCode(dataScope[_userType])
          : [],
      erp: (_userType == 'placeErp' || _userType == 'erp') && dataScope[_userType] ? dataScope[_userType][0] : [],
    };

    form.setFieldsValue(value);
    setOriginFilter(value)
    setFilter(getFilterValue(value));
    setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
  }, [dataScopeFilter, form]);

  const columns = [
    {
      title: '活动名称',
      width: 250,
      render(record) {
        const { planName, activityStatus, planCode } = record;
        return (
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {activityStatus == 2 && <div className="online-tag">进行中</div>}
              {activityStatus == 1 && <div className="ending-tag">已结束</div>}
              <span className="ellipsis-2-line">{planName}</span>
            </div>
            <Copy text={planCode} />
          </>
        );
      },
    },
    {
      title: '活动时间',
      width: 180,
      render(record) {
        const { activityStartTime, activityEndTime } = record;
        return (
          <>
            <div>{moment(activityStartTime).format('YYYY-MM-DD') + '~'}</div>
            <div>{moment(activityEndTime).format('YYYY-MM-DD')}</div>
          </>
        );
      },
    },

    {
      title: '活动类型',
      width: 150,
      dataIndex: 'activityType',
      render(activityType) {
        return activityTypeMap[activityType].label;
      },
    },

    {
      title: (
        <>
          累计引入商详UV
          <IconTip title="通过活动会场页面进入商详页面的UV去重（即流量路径树。以sku为粒度，记录商详前的页面浏览路径，A.通过活动会场页面直接跳转进入sku商详；或B.浏览路径上经过了会场页面最终进入商详，即计为该页面的引入商详。）" />
        </>
      ),
      width: 200,
      dataIndex: 'itemUv',
      sorter: true,
      render: (data) => {
        return formatPrice(data);
      },
    },
    {
      title: (
        <>
          累计直接引导成交订单金额
          <IconTip title="活动页点击商品素材后下一页是商详，且当天内有下单行为(成交)，限制同sku或同spu，产生的订单金额为直接引导成交订单金额" />
        </>
      ),
      width: 200,
      dataIndex: 'zjOrdAmt',
      sorter: true,
      render: (data) => {
        return formatPrice(data);
      },
    },
    {
      title: (
        <>
          累计引入商详UV占比
          <IconTip title="累计引入商详UV/名下所有活跃商品商详UV" />
        </>
      ),
      width: 200,
      dataIndex: 'itemUvRate',
      sorter: true,
      render: (data) => {
        return formatPrice(Number(data) * 100, '-', 1, '%');
      },
    },
    {
      title: (
        <>
          累计直接引导成交订单金额占比
          <IconTip title="累计直接订单金额/名下所有活跃商品成交订单金额" />
        </>
      ),
      width: 200,
      dataIndex: 'zjGmvRate',
      sorter: true,
      render: (data) => {
        return formatPrice(Number(data) * 100, '-', 1, '%');
      },
    },
    {
      title: '操作',
      width: 150,
      render(record) {
        return (
          <a
            onClick={() => {
              // goto.toDataPanelParticipantDataActivityDetail(record).push();
              gotoDetail(record, filter);
            }}
          >
            查看详情
          </a>
        );
      },
    },
  ];

  const onFormChange = (changeValue, val) => {

    if (changeValue.userType) {
      const _userType = changeValue.userType;
      const { dataScope } = dataScopeFilter;
      const value = {
        userType: _userType,
      };
      if ((_userType == 'dept' || _userType == 'placeDept') && dataScope[_userType]) {
        value.dept = findFirstAvailableCode(dataScope[_userType]);
      } else if ((_userType == 'placeErp' || _userType == 'erp') && dataScope[_userType]) {
        value.erp = dataScope[_userType][0];
      }
      form.setFieldsValue(value);
      setOriginFilter(value)
      setFilter(getFilterValue(value));
      setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
    } else if(changeValue.dept || changeValue.erp) {
      const value = form.getFieldsValue(true);
      setOriginFilter(value)
      setFilter(getFilterValue(value));
      setUserType(getFilterValue(value).userType === 'placeErp' ? 'placeErp' : 'other')
    }
    else{
      setConditions((conditions) => Object.assign({}, conditions, val, { pageNum: 1 }));
    }
  };

  function NoAccess() {
    return (
      <div style={{padding: '20px 0'}}>
        <CommonNoAccess/>
      </div>
      // <Empty
      //   style={{ paddingTop: 250, paddingBottom: 250 }}
      //   description="名下有品的erp或部门Leader自动获取活动看数权限，品类营销角色需要申请部门权限
      //   https://joyspace.jd.com/pages/ldroyXUSUXH8wnE1f6Uc
      //   如有疑问请进咚咚群咨询:10202084337"
      // />
    );
  }

  return !dataScopeFilter?.userType?.length ? (
    <NoAccess />
  ) : (
    <>
      <Form
        onFinish={onFinish}
        form={form}
        onValuesChange={onFormChange}
        className="activity-participation-effect-table-form"
      >
        <Row gutter={16}>
          <Col>
            <Form.Item
              name="userType"
              label={
                <span>
                数据范围
                <IconTip title="选择您有权限的角色及数据范围。运营部门/ERP代表采销控分离前的部门/采销，销售部门/ERP代表采销控分离后的部门/销售。如有疑问请进咚咚群咨询:10202084337。" />
              </span>
              }
              initialValue={dataScopeFilter.userType[0].key}
            >
              <Select style={{ width: 160 }} disabled={!!inSecKill}>
                {dataScopeFilter?.userType?.map((item) => (
                  <Select.Option value={item.key} key={item.key}>
                    {item.value}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item noStyle shouldUpdate={(prevValue, curValue) => prevValue.userType !== curValue.level}>
              {({ getFieldValue }) => {
                const userType = getFieldValue('userType');
                if (userType == 'dept' || userType == 'placeDept') {
                  return (
                    <Form.Item
                      name="dept"
                    >
                      <TreeSelect
                        disabled={!!inSecKill}
                        style={{ width: 200 }}
                        changeOnSelect
                        allowClear={false}
                        fieldNames={{ label: 'name', value: 'deptFullCode', children: 'children' }}
                        treeData={dataScopeFilter.dataScope[userType]}
                        treeNodeLabelProp="deptFullName"
                      />
                    </Form.Item>
                  );
                }
                if (userType == 'placeErp' || userType == 'erp') {
                  return (
                    <Form.Item
                      name="erp"
                    >
                      <Select
                        disabled={!!inSecKill}
                        style={{ width: 160 }}
                        showSearch
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                      >
                        {dataScopeFilter.dataScope[userType]?.map((item) => (
                          <Select.Option value={item} key={item}>
                            {item}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  );
                }
              }}
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="activityType" label="活动类型">
              <Select options={activityType} placeholder="请选择活动类型" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="activityCycle" label="活动周期">
              <Select options={activityCycle} placeholder="请选择活动周期" allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="activityStatus" label="活动状态">
              <Select options={activityStatus} placeholder="请选择活动状态" allowClear />
            </Form.Item>
          </Col>
          <Col flex="auto">
            <Form.Item name="planName" label="活动名称">
              <Input placeholder="请输入活动名称搜索" allowClear />
            </Form.Item>
          </Col>
        </Row>

      </Form>
      <Table
        style={{ marginTop: 16 }}
        columns={columns}
        dataSource={data.skuPoolPlanInfos}
        pagination={{
          total: data.total,
          current: conditions.pageNum,
          pageSize: conditions.pageSize,
          // pageSizeOptions: [10, 20, 50, 100],
          // showSizeChanger: true,
          showQuickJumper: true,
        }}
        onChange={(pagination, filters, sorter, { action }) => {
          let _val = {};
          if (action == 'sort') {
            _val = {
              orderBy: sorter.order && sorter.field,
              sequence: sorter.order?.replace('end', ''),
              pageNum: 1,
            };
          }
          if (action == 'paginate') {
            _val = { pageNum: pagination.current };
          }
          setConditions((conditions) => Object.assign({}, conditions, _val));
        }}
      />
    </>
  );
}

export default withRouter(ActivityTable);
